import React from 'react';
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';

import "./event_promotion.scss";

import { getText, styleToObj, openItem, getIndexById } from "../../utils/functions";
import BetBanner from "./component/BetBanner";
import { makeGetLiveMatchState, makeGetPrematchMatchState } from "../../store/selector/lobbyData";
import { ReactComponent as LobbyArrow } from "../../assets/arrow.svg";

const empty = {};

const EventPromotion = (props) => {
  const { data, i18n, source, liveMatches, prematchMatches } = props;

  const lang = i18n.language;

  const [items, setItems] = React.useState([]);

  React.useEffect(() => {
    if (data.data_source && source.length) {
      setItems(source);
    }
  }, [data.data_source, data.thumbnail_size, source]);

  if (items.length === 0) return null;

  const filteredItems = items.filter(item => {
    if (item.mType && item.idMatch) {
      if (item.mType === "live" && typeof liveMatches[item.idMatch] !== "undefined") return true;
      if (item.mType === "prematch" && typeof prematchMatches[item.idMatch] !== "undefined") return true;
    }
    return false;
  });

  if (filteredItems.length === 0) return null;

  const title = getText(data, `title.text.${lang}`, "");
  const navigateTitle = getText(data, `navigate.text.${lang}`, "");

  return (
    <div className={`component-event_promotion component`} style={styleToObj(data.style)}>

      <div className="cgl-header">
        {!!title && <div className="title" style={styleToObj(data.title.style)}>
          {getText(data, `title.text.${lang}`, "")}
        </div>}
        {!!navigateTitle && <div
          className="link"
          style={styleToObj(data.navigate.style)}
          data-type={"navigate"}
          data-item={JSON.stringify({ url: data && data.navigate && data.navigate.url ? data.navigate.url : "" })}
          onClick={openItem}
        >
          {getText(data, `navigate.text.${lang}`, "")}
          {filteredItems.length !== 0 && <span>({filteredItems.length})</span>}
          <LobbyArrow />
        </div>}
      </div>

      <div className="cgl-list with-scroll-style" style={styleToObj(data.data_source_style)}>
        <div className={`cgl-grid`}>
          {filteredItems.map((item, i) => {
            const realIndex = getIndexById(items, item.id);
            const itemStyle = typeof data.data_source_items[realIndex.toString()] !== "undefined" ? styleToObj(data.data_source_items[realIndex].style) : empty;

            return <div className={`cgl-item`} key={i} style={itemStyle}>
              <div className="outer">
                <div className="inner">
                  <div className="bg-img">
                    {item.image && <img src={item.image} alt="" />}
                  </div>
                  <div className="content-wrapper">
                    <BetBanner mType={item.mType} idMatch={item.idMatch} />
                  </div>
                </div>
              </div>
            </div>;
          })}
        </div>
      </div>

    </div>
  );
}

const getPrematchMatches = makeGetPrematchMatchState();
const getLiveMatches = makeGetLiveMatchState();

const mapStateToProps = (state, props) => {
  let source = [];
  let dsId = props.data && props.data.data_source && props.data.data_source.id ? props.data.data_source.id : null;
  if (dsId) {
    if (typeof state.config.lobbyDataSources[dsId] !== "undefined") {
      source = state.config.lobbyDataSources[dsId].meta ? state.config.lobbyDataSources[dsId].meta : [];
    }
  }

  return {
    source: source,
    liveMatches: getLiveMatches(state, props),
    prematchMatches: getPrematchMatches(state, props),
  }
};

export default withTranslation()(connect(mapStateToProps)(EventPromotion));